import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.div`
  text-align: center;
  > img {
    height: 142px;
    display: block;
    margin: auto;
  }
`;

const ImageTextWrapper = styled.div`
  display: flex;
  align-items: center;
  .imageWrapper {
    width: 64px;
    height: 64px;
    overflow: hidden;
    flex-shrink: 0;
    border: 1px solid ${({ theme }) => theme.palette.grey[4]};
    border-radius: ${({ theme }) => theme.shape.borderRadius}px;
    display: flex;
    align-items: center;
    justify-content: center;


    img {
      display: block;
      width: calc(100% - ${({ theme }) => theme.spacing}px);
    }

    .imgAltText {
      color: ${({ theme }) => theme.palette.grey[2]};
    }
  }

  .textWrapper {
    margin-left: ${({ theme }) => theme.spacing * 2}px;
    text-align: left;
    p{
      margin:0 0 ${({ theme }) => theme.spacing}px;
    }
    .title {
      text-transform: capitalize;
      font-weight: 700;
    }
  }
`;

const Chip = styled.span`
  display: inline-block;
  border-radius: ${({ theme }) => theme.shape.borderRadius * 3}px;
  padding: ${({ theme }) => theme.spacing / 2}px ${({ theme }) => theme.spacing * 2}px;
  background-color: ${({ theme }) => theme.palette.grey[4]};
  color: ${({ theme }) => theme.palette.primary.main};
  margin-top:${({ theme }) => theme.spacing}px;
`;

const ImageAndText = ({ title, subtitle, imgUrl }) => (
  <ImageTextWrapper>
    <div className="imageWrapper">
      {imgUrl ? (
        <img src={imgUrl} alt={title} />
      ) : (
        <div className="imgAltText">
          <small>Image coming soon</small>
        </div>
      )}
    </div>
    <div className="textWrapper">
      <p className="title">{title}</p>
      <p className="subtitle">{subtitle}</p>
    </div>
  </ImageTextWrapper>
);

const ProductImage = ({
  item, format, chip,
}) => {
  const [imgExists, setImgExists] = React.useState(false);

  const largeImage = <img src={item.url} alt={item.title} />;
  const thumbnailAndText = (
    <ImageAndText
      title={item.title}
      subtitle={item.subTitle}
      imgUrl={imgExists ? item.url : null}
    />
  );

  const renderMap = {
    largeImage: imgExists ? largeImage : thumbnailAndText,
    thumbnailAndText,
  };

  React.useLayoutEffect(() => {
    setImgExists(false);

    const prodImage = new Image();
    prodImage.onload = () => {
      setImgExists(true);
    };
    prodImage.src = item.url;
  }, [setImgExists, item.url]);

  return (
    <Wrapper className="ProductImage">
      {renderMap[format]}
      {chip && <Chip>{chip}</Chip>}
    </Wrapper>
  );
};

ProductImage.displayName = 'ProductImage';

ProductImage.propTypes = {
  item: PropTypes.shape({
    type: PropTypes.oneOf(['Occasional', 'Part Time', 'Full Time', 'Monthly'])
      .isRequired,
    title: PropTypes.string,
    subTitle: PropTypes.string,
    styleNumber: PropTypes.string,
    solution: PropTypes.bool,
    url: PropTypes.string,
  }).isRequired,
  format: PropTypes.oneOf(['largeImage', 'thumbnailAndText']),
  chip: PropTypes.string,
};

ProductImage.defaultProps = {
  format: 'largeImage',
  chip: undefined,
};

ImageAndText.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  imgUrl: PropTypes.string,
};
ImageAndText.defaultProps = {
  subtitle: null,
  imgUrl: null,
};

export default ProductImage;
